/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import * as React from 'react';
import CalculatorCard from './CalculatorCard';
import './CalculatorCardCollection.scss';
import paramConfig from '../../../modules/calculator/parameterConfig_NEW.json';
import { ScrollNavContext } from '../../context/ScrollNavContext';
import { CalculatorResult, ParameterModifier, ParameterName } from '../../../modules/calculator/calculatorTypes';
import { ModalType } from '../modals/Modals';
import { OptionsConfig } from '../modals/OptionsModal';
//import OverviewCard from './OverviewCard';
import { isMobileOnly } from 'react-device-detect';
import { UnitPreset } from '../../../modules/units/unitTypes';
import { Size, Button, ButtonType, Icon } from '@vaisala-rockhopper/components';
import { VaiIcon } from '@vaisala-rockhopper/design-tokens';
import { useTranslation } from 'react-i18next';

interface CalculatorCardCollectionProps {
  currentResult?: CalculatorResult;
  onParameterChange: (cardIndex: number, parameterName: ParameterName, value: ParameterModifier, phase?: number) => void;
  activeMethod: number;
  variant?: string;
  openModal: (type: ModalType, title?: string, optionsConfig?: OptionsConfig, onAccept?: VoidFunction, onReject?: VoidFunction) => void;
  currentUnitPreset: UnitPreset | undefined;
  theme: string;
  onReset?: () => void;
}

const CalculatorCardCollection = React.forwardRef(
  (
    { onParameterChange, currentResult, activeMethod, variant, openModal, currentUnitPreset, theme, onReset }: CalculatorCardCollectionProps,
    ref: any
  ) => {
    const { t } = useTranslation();
    const [activePhase] = React.useContext(ScrollNavContext);
    const config = paramConfig.methods.find((method) => method.id === activeMethod);

    return (
      <div
        className={`calculator-card-collection ${variant ? `calculator-card-collection--${variant}` : 'calculator-card-collection--default'} ${
          isMobileOnly ? 'calculator-card-collection--mobile' : ''
        }`}
      >
        {config &&
          config.cards.map((cardConfig: any, i: number) => {
            return (
              <CalculatorCard
                variant={variant}
                key={i}
                config={cardConfig}
                cardsLength={config?.cards?.length}
                cardIndex={i}
                phase={i + 1}
                active={i + 1 === activePhase}
                currentResult={currentResult}
                onParameterChange={(parameterName: ParameterName, value: ParameterModifier, phase?: number) =>
                  onParameterChange(i, parameterName, value, phase)
                }
                openModal={openModal}
                //ref={i === config.cards.length - 1 && variant === 'graph' ? ref : null}
                ref={i === config.cards.length - 1 ? ref : null}
                currentUnitPreset={currentUnitPreset}
                theme={theme}
                activeMethod={activeMethod}
              />
            );
          })}
        <Button
          className="mobile-calculator__reset"
          buttonType={ButtonType.Link}
          buttonSize={Size.S}
          startIcon={<Icon name={VaiIcon.Refresh} />}
          onClick={onReset}
        >
          {t('ui.reset')}
        </Button>
        {/* <OverviewCard ref={variant !== 'graph' ? ref : null} currentResult={currentResult} variant={variant} /> */}
      </div>
    );
  }
);

export default CalculatorCardCollection;
